import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'rt-chips',
  standalone: true,
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.less'],
  imports: [IconComponent],
})
export class ChipsComponent {
  @Input({ required: true }) public text: string;
  @Input() public showClose: boolean = true;

  @Output() public close: EventEmitter<void> = new EventEmitter<void>();
}
